import { IVersionGroupService } from "./interface";
import {
	VersionGroupModel,
	VersionGroupRequestModel,
	UserVCSSettingResponseModel,
	UserVcsSettingsSaveModel
} from "./model";
import { GLServiceBase, ServiceRoute } from "@/commonui/services";

class VersionGroupServiceClass extends GLServiceBase<any, any> implements IVersionGroupService {
	serviceRoute: ServiceRoute = { prefix: "content/v1/vcsVersion" };

	getVersions(includePublishedOnly: boolean): Promise<VersionGroupModel[]> {
		return this.get("getversiongroups", { includePublishedOnly });
	}

	createVersions(versions: VersionGroupRequestModel[]): Promise<string> {
		return this.create("createVersionGroups", versions);
	}

	publishVersion(versionGroupId: string): Promise<boolean> {
		return this.request.put(this.serviceRoute.prefix + "/publishVersionGroup?versionGroupId=" + versionGroupId);
	}

	getVcsSettings(): Promise<UserVCSSettingResponseModel> {
		return this.get("getUserVCSSetting");
	}

	saveVersionGroupSelected(selected: UserVcsSettingsSaveModel): Promise<boolean> {
		return this.create("saveUserVCSSetting", selected);
	}
}

export const VersionGroupService = () => new VersionGroupServiceClass();
